import React from 'react';
import unAuthSVG from '../Logos/access_denied.svg'
function UnauthorizedAccess() {
    return (
        <div className='row col-lg-3 col-md-4 col-sm-6 col-6 m-auto'>
            <img className="" style={{ marginTop: "20px" }} src={unAuthSVG} alt="image" />
        </div>
    );
}

export default UnauthorizedAccess;